<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ `${header}  ${$t('approval_workflow.entity_name').toLowerCase()}` }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2" v-if="workflowAction === 302">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('approval_workflow.entity_name') }}</label>
            <el-form-item prop="newWorkflow">
              <el-select
                v-model="form.newWorkflow"
                filterable
                clearable
                :placeholder="$t('app.select')"
                :disabled="isLoadingSelect"
                class="w-full">
                <el-option
                  v-for="item in workflowList"
                  :key="item.IdFlujoAprobacion"
                  :label="item.Nombre"
                  :value="item.IdFlujoAprobacion"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="lg:mb-2">
            <div ref="Comentario">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isRejectOrReasignAction"/>{{ $t('approval_workflow.comentary') }}</label>
               <el-form-item prop="Comentario">
                 <el-input
                   clearable
                   class="w-full"
                   v-model="form.Comentario"
                   maxlength='2500'
                   type="textarea"
                   :rows="3"
                 />
               </el-form-item>
            </div>
          </div>

        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div  class="flex flex-row items-center w-full justify-between space-x-2 bg-white mt-auto dark:bg-darkblue-900">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" class="w-full" :text="$t('app.cancel')" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply('ruleForm')" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { getAllWorkflows } from '@/services/configurations/workflow/getAllWorkflows'

export default
{
  name: 'invoice-workflow-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    workflowAction: {
      type: Number,
      default: null,
    },
    header: {
      type: String,
      default: null,
    },
    idFlujoAprobacion: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        newWorkflow: '',
        Comentario: '',
        action: ''
      },
      loadingWorkflowSelect: false,
      workflowList: [],
    }
  },
  mounted: async function () {
    this.reloadData()
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.reloadData()
      }
    },
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isRejectOrReasignAction: function () {
      return this.workflowAction === 301 || this.workflowAction === 302
    },
    isLoadingSelect: function () {
      return this.loadingWorkflowSelect
    },
    rules: function () { 
      return {
        newWorkflow: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
        Comentario: [
          { 
            required: this.isRejectOrReasignAction,
            message: i18n.t('validation.complete'),
            trigger: 'blur' 
          }
        ]
      }
    }
  },
  methods: {
    reloadData: async function () {
      this.loadingWorkflowSelect = true
      try {
        const data = await getAllWorkflows()
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          this.workflowList = data.Flujos
          if (this.idFlujoAprobacion && this.idFlujoAprobacion.length > 0) {
            this.workflowList = this.workflowList.filter(workflow => workflow.IdFlujoAprobacion !== this.idFlujoAprobacion[0])
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingWorkflowSelect = false
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form = {
        newWorkflow: '',
        Comentario: '',
        action: ''
      }
    },
    apply: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.action = this.workflowAction
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
          this.form = {
            newWorkflow: '',
            Comentario: '',
            action: ''
          }
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
